import React, {useState, useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {BlueGradientBackground} from '../components/AuthForm'
import {ThryvAndKeapHeader} from './order-details'
import {SchedulerAppointmentComponent} from '../components/keap-scheduler-v2/scheduler-appointment'
import {SchdulerSuccessComponent} from '../components/keap-scheduler-v2/scheduler-success'
import {KCPPaymentDetails} from '../components/subscription-summary'
import '../styles/formScreensStyles.css'

export const AppointmentDetailsComponent = () => {
  const navData = useLocation()
  const navigate = useNavigate()
  const [isScheduleCompleted, setScheduleCompletedStatus] = useState(false)
  const [scheduleKickOffCallDetails, setScheduledKickOffCallDetails] =
    useState(null)
  const [scheduleCreativeCallDetails, setScheduledCreativeCallDetails] =
    useState(null)
  const [isInitialLoad, setIsInitialLoad] = useState(true)

  // Initialize with default structure to prevent errors
  const [structuredCart, setStructuredCart] = useState({
    centers: [],
    apps: [],
    oneTimeFees: [],
    plans: [],
  })

  useEffect(() => {
    console.log('=== APPOINTMENT PAGE DEBUG ===')
    console.log('navData:', navData)
    console.log('navData.state:', navData?.state)
    console.log('navData.state.orderDetail:', navData?.state?.orderDetail)
    console.log(
      'navData.state.accountInformation:',
      navData?.state?.accountInformation,
    )
    console.log(
      'accountInformation.email:',
      navData?.state?.accountInformation?.email,
    )
    console.log(
      'accountInformation.address:',
      navData?.state?.accountInformation?.address,
    )

    // The orderDetail is already formatted from order-details page
    if (navData?.state?.orderDetail) {
      const orderDetail = navData.state.orderDetail
      console.log('Setting structuredCart with orderDetail:', orderDetail)

      // Check if orderDetail has productSub with the structured data
      if (orderDetail.productSub) {
        console.log('Found productSub:', orderDetail.productSub)

        // Extract centers, apps, and oneTimeFees from productSub
        const parentSubs = orderDetail.productSub.parentSubscriptions || []
        const childSubs = orderDetail.productSub.childSubscriptions || []

        // Combine all subscriptions
        const allSubs = [...parentSubs, ...childSubs]

        // Separate into centers, apps, and oneTimeFees based on the plans array
        const centers = []
        const apps = []
        const oneTimeFees = []

        // Process all subscriptions and their addons
        allSubs.forEach(sub => {
          // Add the subscription itself
          if (sub.code?.includes('center') || sub.type === 'center') {
            centers.push(sub)
          } else if (sub.code?.includes('fee') || sub.type === 'oneTimeFee') {
            oneTimeFees.push(sub)
          } else {
            apps.push(sub)
          }

          // Process addons
          if (sub.addons && Array.isArray(sub.addons)) {
            sub.addons.forEach(addon => {
              if (addon.code?.includes('fee') || addon.type === 'oneTimeFee') {
                oneTimeFees.push(addon)
              } else {
                apps.push(addon)
              }
            })
          }
        })

        const structured = {
          centers,
          apps,
          oneTimeFees,
          plans: orderDetail.plans || [],
        }

        console.log('Structured cart:', structured)
        setStructuredCart(structured)
      } else {
        // Fallback: use the orderDetail as-is and add empty arrays
        console.log('No productSub found, using orderDetail with defaults')
        setStructuredCart({
          centers: [],
          apps: [],
          oneTimeFees: [],
          plans: orderDetail.plans || [],
          ...orderDetail,
        })
      }
    } else {
      console.warn('No orderDetail found in navData.state!')
    }
  }, [navData])

  useEffect(() => {
    console.log('structuredCart updated:', structuredCart)
    console.log('structuredCart.apps:', structuredCart?.apps)
    console.log('structuredCart.centers:', structuredCart?.centers)
    console.log('structuredCart.oneTimeFees:', structuredCart?.oneTimeFees)
  }, [structuredCart])

  useEffect(() => {
    // Scroll to top when initial load completes
    if (isInitialLoad && structuredCart.plans.length > 0) {
      window.scrollTo({top: 0, behavior: 'smooth'})
      setIsInitialLoad(false)
    }
  }, [structuredCart, isInitialLoad])

  useEffect(() => {
    // Scroll to top when schedule is confirmed
    if (isScheduleCompleted) {
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
  }, [isScheduleCompleted])

  const handleScheduleSuccessStatus = () => setScheduleCompletedStatus(true)

  const handleContinue = () => {
    navigate('/client-payment', {
      state: {
        ...navData.state,
        scheduleKickOffCallDetails,
        scheduleCreativeCallDetails,
      },
    })
  }

  // Check if website product is present in  navData.state.orderDetail
  const isProductInOrder = (items, productCode) => {
    for (const item of items) {
      if (item.code === productCode) {
        return item
      }
      if (item.addons && item.addons.length > 0) {
        const foundAsAddon = item.addons.find(addon => {
          if (addon.code === productCode) {
            return addon
          }
        })

        if (foundAsAddon) {
          return foundAsAddon
        }
      }
    }
    return null
  }
  // Determine which calls exist based on the cart
  const isKickOffCallExist = true // You may need to determine this from navData.state.orderDetail
  const isCreativeCallExist = isProductInOrder(
    navData?.state?.orderDetail?.productSub.childSubscriptions,
    'ent-5-website',
  )
    ? true
    : false // You may need to determine this from navData.state.orderDetail
  return (
    <>
      <BlueGradientBackground showLogo={false} backgroundHexColor="#F4F6FB" />
      <ThryvAndKeapHeader />
      <section
        style={{
          display: 'grid',
          gridTemplateColumns: '60% 40%',
          width: '100%',
          minHeight: '100vh',
        }}
      >
        {/* Left side - Appointment Scheduler */}
        <section
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: '80px',
            paddingRight: '40px',
            paddingTop: '40px',
            maxWidth: '100%',
            overflow: 'hidden',
          }}
        >
          <h2
            style={{
              paddingBottom: '20px',
              fontWeight: 700,
              fontFamily: 'Open Sans',
              fontSize: '32px',
              lineHeight: '100%',
              color: '#FFFFFF',
            }}
          >
            Schedule Appointment
          </h2>
          {isScheduleCompleted ? (
            <SchdulerSuccessComponent
              isKickOffCallExist={isKickOffCallExist}
              isCreativeCallExist={isCreativeCallExist}
              scheduleCreativeCallDetails={scheduleCreativeCallDetails}
              scheduleKickOffCallDetails={scheduleKickOffCallDetails}
              accountInformation={navData.state?.accountInformation}
              handleModalClose={handleContinue}
            />
          ) : (
            <div
              style={{
                backgroundColor: '#F5F5F5',
                padding: '30px',
                borderRadius: '8px',
              }}
            >
              <SchedulerAppointmentComponent
                isKickOffCallExist={isKickOffCallExist}
                isCreativeCallExist={isCreativeCallExist}
                scheduleCreativeCallDetails={scheduleCreativeCallDetails}
                scheduleKickOffCallDetails={scheduleKickOffCallDetails}
                setScheduledCreativeCallDetails={
                  setScheduledCreativeCallDetails
                }
                setScheduledKickOffCallDetails={setScheduledKickOffCallDetails}
                handleScheduleSuccessStatus={handleScheduleSuccessStatus}
                accountInformation={navData.state?.accountInformation}
                transitionData={navData}
                structuredCart={structuredCart}
              />
            </div>
          )}
        </section>

        {/* Right side - Payment Details Summary */}
        <section
          style={{
            background: 'white',
            minHeight: '100vh',
            paddingBlock: '90px',
            paddingInline: '60px',
            borderLeft: '1px solid #ECEEF1',
          }}
        >
          <h2
            style={{
              fontFamily: 'Open Sans',
              fontWeight: 600,
              fontSize: '28px',
              lineHeight: '44px',
              marginBottom: '30px',
            }}
          >
            Payment Details
          </h2>
          <section
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '40px',
            }}
          >
            <KCPPaymentDetails
              cartDetailObj={navData.state?.orderDetail}
              paymentDetailType="monthly"
              currentScreen={'appointment'}
            />
            <KCPPaymentDetails
              paymentDetailType="today"
              cartDetailObj={navData.state?.orderDetail}
              currentScreen={'appointment'}
              couponList={navData.state?.couponList}
            />
          </section>
        </section>
      </section>
    </>
  )
}
